import axios from 'axios';

const baseUrl = process.env.REACT_APP_DIFLEX_API_URL + "/agreements";

export async function getManagedDevicesByAgreement(agreementPublicId, apiAccessToken) {
  try {
    const response = await axios.get(
      `${baseUrl}/ManagedDevices/get-by-agreement-dip/${agreementPublicId}`,
      {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${apiAccessToken}`
        }
      }
    );
    return response.data;
  } catch (error) {
    throw new Error(error?.response?.data?.message || 'Failed to fetch managed devices');
  }
}

export async function getManagedDeviceByPublicId(publicId, apiAccessToken) {
  try {
    const response = await axios.get(
      `${baseUrl}/ManagedDevices/get-by-public-id-dip/${publicId}`,
      {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${apiAccessToken}`
        }
      }
    );
    return response.data;
  } catch (error) {
    throw new Error(error?.response?.data?.message || 'Failed to fetch managed device');
  }
}
